import { CommonModule, isPlatformBrowser } from '@angular/common';
import type { OnInit, OnDestroy } from '@angular/core';
import { Component, inject, PLATFORM_ID } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import type { Subscription } from 'rxjs';

import { ApiLoaderComponent } from './core/api-loader/api-loader.component';
import { NetworkService } from './services/network.service';
import { environment } from '../enviroment/enviroment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ApiLoaderComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'fe-qautos';

  titleService = inject(Title);
  metaService = inject(Meta);
  router = inject(Router);
  networkService = inject(NetworkService);
  platformId = inject(PLATFORM_ID);

  isOnline = true;
  private subscription!: Subscription;
  private readonly isBrowser = isPlatformBrowser(this.platformId);
  supportPhone = environment.ANGULAR_SUPPORT_PHONE;
  supportPhoneShow = environment.ANGULAR_PHONE_SHOW;
  supportEmail = environment.ANGULAR_SUPPORT_EMAIL;
  isChatOpen = false;

  ngOnInit(): void {
    this.titleService.setTitle('Qautos | Rental');
    this.metaService.updateTag({
      name: 'description',
      content: 'The premier ride experience',
    });
    if (this.isBrowser) {
      localStorage.setItem('theme', 'light');
    }
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => this.hideSplash(), 100);
      }
    });

    this.subscription = this.networkService.online$.subscribe((status) => {
      this.isOnline = status;
    });
  }

  hideSplash(): void {
    if (typeof window === 'undefined') {
      return;
    }
    const SPLASH = document.getElementById('splash-screen');
    if (SPLASH) {
      SPLASH.style.opacity = '0';
      SPLASH.style.transition = 'opacity 0.3s ease';
      SPLASH.remove();
    }
  }

  toggleChat(): void {
    this.isChatOpen = !this.isChatOpen;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
